import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()
export class LocalStorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }

  public getValue(key, toJson): any {
    if (isPlatformBrowser(this.platformId)) {
      const value = localStorage.getItem(key);
      return toJson ? JSON.parse(value) : value;
    }
  }

  public setValue(key, value): any {
    if (isPlatformBrowser(this.platformId)) {
      value = typeof value === 'object' ? JSON.stringify(value) : value;
      return localStorage.setItem(key, value);
    }
  }

  public remove(key): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }

  public hasValue(key): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key) !== null;
    }
  }
}
